import React, { useState, useEffect } from 'react';
import Entete from './Entetes';
import { Card, Tab, Nav } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import { getCaisse, getRecapCaisses } from 'data/Finance/caisse';

const TabTitle = ({ title, type, recap }) => (
  <div className="p-2 pe-4 text-start cursor-pointer">
    <h6 className="text-800 fs-11 text-nowrap">{title}</h6>
    {type == 'Tous' ? (
      <h5 className="text-800">
        {(recap &&
          recap
            .map(item => item.debit)
            .reduce((a, b) => a + b, 0)
            .toFixed(3)) ||
          '0.000'}
      </h5>
    ) : (
      <h5 className="text-800">
        {(recap && recap.find(item => item.type == type)?.debit.toFixed(3)) || '0.000'}
      </h5>
    )}
    {/* <Flex alignItems="center">
      <FontAwesomeIcon
        icon={progress ? 'caret-up' : 'caret-down'}
        className={progress ? 'text-success' : 'text-warning'}
      />
      <h6 className={`fs-11 mb-0 ms-2 ${progress ? 'text-success' : 'text-warning'}`}>
        {percentage}
      </h6> 
    </Flex>*/}
  </div>
);

const Caisse = () => {
  const [Data, setData] = useState([]);
  const [recap, setRecap] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCaisse();
        //const result = await response.json();
        console.log(response);
        setData(response);
        const recap = await getRecapCaisses();
        setRecap(recap);
        console.log(recap);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Card className={'overflow-hidden'}>
        <Tab.Container id="audience-tab" defaultActiveKey="Tous">
          <SimpleBar>
            <Card.Header className="p-0 bg-body-tertiary">
              <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
                <Nav.Item>
                  <Nav.Link className="mb-0" eventKey="Tous">
                    <TabTitle title="Tous" recap={recap} type="Tous" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="mb-0" eventKey="Espece">
                    <TabTitle title="Espèces" recap={recap} type="Espece" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="mb-0" eventKey="Virements">
                    <TabTitle title="Virements" recap={recap} type="Virement" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="mb-0" eventKey="Chèques">
                    <TabTitle title="Chèques" recap={recap} type="Chèque" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="mb-0" eventKey="Traites">
                    <TabTitle title="Traites" recap={recap} type="Traites" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="mb-0" eventKey="Autres">
                    <TabTitle title="Autres" recap={recap} type="Autres" />
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>
          </SimpleBar>

          <Card.Body>
            <Tab.Content>
              <Tab.Pane unmountOnExit eventKey="Tous">
                <Entete data={Data} type="Tous" />
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="Espece">
                <Entete data={Data} type={0} />
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="Virements">
                <Entete data={Data} type={2} />
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="Chèques">
                <Entete data={Data} type={1} />
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="Traites">
                <Entete data={Data} type={3} />
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="Autres">
                <Entete data={Data} type={4} />
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Tab.Container>

        <Card.Footer className="bg-body-tertiary py-2">
          {/* <Row className="g-0 flex-between-center">
          <Col xs="auto">
            <Form.Select size="sm" className="me-2">
              <option>Last 7 days</option>
              <option>Last Month</option>
              <option>Last Year</option>
            </Form.Select>
          </Col>
          <Col xs="auto">
            {/* <FalconLink title="Visitors overview" className="px-0 fw-medium" /> 
          </Col>
        </Row> */}
        </Card.Footer>
      </Card>
    </>
  );
};

export default Caisse;
